import { css } from "styled-components"

const rawHtmlCss = css`
  a,
  p > a {
    color: ${props => props.theme.colors.linkPrimary};
  }

  a:visited,
  p > a:visited {
    color: ${props => props.theme.colors.linkPrimary};
  }

  a:focus,
  a:hover,
  p > a:focus,
  p > a:hover {
    color: ${props => props.theme.colors.linkPrimary};
  }

  em {
    font-size: inherit;
    font-style: italic;
  }

  h1,
  h2,
  h3,
  h4 {
    margin-bottom: 50px;
  }

  h5,
  h6,
  p {
    margin-bottom: 40px;
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.text.header};
    line-height: ${props => props.theme.lineHeights.header};
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.text.title};
    line-height: ${props => props.theme.lineHeights.primary};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.text.title};
    line-height: ${props => props.theme.lineHeights.primary};
  }

  h4 {
    font-size: ${props => props.theme.fontSizes.text.primary};
    line-height: ${props => props.theme.lineHeights.primary};
  }

  h5 {
    font-size: ${props => props.theme.fontSizes.text.primary};
    line-height: ${props => props.theme.lineHeights.primary};
  }

  h6 {
    font-size: ${props => props.theme.fontSizes.text.primary};
    line-height: ${props => props.theme.lineHeights.primary};
  }

  li,
  p {
    color: inherit;
    font-family: ${props => props.theme.fonts.karla};
    line-height: ${props => props.theme.lineHeights.primary};
  }

  h1:last-child,
  h2:last-child,
  h3:last-child,
  h4:last-child,
  h5:last-child,
  h6:last-child,
  p:last-child {
    margin-bottom: 0;
  }

  strong {
    font-weight: ${props => props.theme.fontWeights.bold};
  }

  @media screen and (max-width: 40em) {
    h1 {
      font-size: ${props => props.theme.fontSizes.text.headerMobile};
    }

    h2 {
      font-size: ${props => props.theme.fontSizes.text.titleMobile};
    }

    h3 {
      font-size: ${props => props.theme.fontSizes.text.titleMobile};
    }

    h4 {
      font-size: ${props => props.theme.fontSizes.text.primaryMobile};
    }

    h6 {
      font-size: ${props => props.theme.fontSizes.text.primary};
    }

    li,
    p {
      font-size: ${props => props.theme.fontSizes.text.primary};
    }
  }
`

export default rawHtmlCss
